
    <fieldmagic-dialog
      icon="plus-circle"
      label="add_checklist"
      [instance]="self"
      [disableClose]="saving$ | async"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <convert-pdf-with-ai-button
          (uploaded)="onGenerate($event)"
          [moduleOrigin]="'checklist'"
          [purpose]="'pdf_checklist_ai'"
          [data]="{
            checklist_type: form.value | data_get: 'checklist_type.id',
            asset_type_id: form.value | data_get: 'asset_type_id.id',
            name: form.value | data_get: 'name',
            specifics: specifics,
            mode: 'add'
          }"
        >
        </convert-pdf-with-ai-button>
        <checklists-generate-with-ai-button
          (generated)="onGenerate($event)"
          [data]="{
            checklist_type: form.value | data_get: 'checklist_type.id',
            asset_type_id: form.value | data_get: 'asset_type_id.id',
            name: form.value | data_get: 'name',
            specifics: specifics
          }"
        >
        </checklists-generate-with-ai-button>

        <fieldmagic-primary-button
          purpose="save"
          [isInProgress]="saving$ | async"
          (click)="onSave()"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div
          fieldmagicGridRow
          [formGroup]="form"
        >
          <div
            fieldmagicGridColumn="12"
          >
            <fieldmagic-text-input
              formControlName="name"
              [errors]="errors | data_get: 'name'"
              label="Name"
              [standalone]="false"
              [withRequiredMarker]="true"
            >
            </fieldmagic-text-input>
          </div>

          <div
            fieldmagicGridColumn="12"
          >
            <fieldmagic-dropdown-input
              formControlName="checklist_type"
              [errors]="errors | data_get: 'checklist_type'"
              label="Checklist Type"
              [withRequiredMarker]="true"
              [options]="types$ | async"
            >
            </fieldmagic-dropdown-input>
          </div>

          <div
            *ngIf="shouldShowAssetTypesField$ | async"
            fieldmagicGridColumn="12"
          >
            <fieldmagic-relate-input
              label="Asset Type"
              formControlName="asset_type_id"
              moduleName="asset_types"
              [withRequiredMarker]="true"
              [errors]="errors | data_get: 'asset_type_id'"
              [withServerAdditionalFilter]="false"
            >
            </fieldmagic-relate-input>
          </div>

        </div>
      </ng-template>
    </fieldmagic-dialog>
  